import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="relative inline-block mb-8">
          <div className="absolute inset-0 rounded-full bg-accent-100/60 blur-2xl scale-150" />
          <div className="relative px-8 py-5 rounded-2xl bg-white border border-background-200/70">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Start Exploring the Largest CSSBuy Spreadsheet Today
            </h2>
            <p className="text-sm text-foreground-500 mb-6">
              Thousands of verified products. Daily updates. Trusted sellers. Free access.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                cssbuy sheet — Shop Now
              </a>
              <Link
                to="/article/cssbuy-spreadsheet-guide"
                className="px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-700 text-sm font-semibold hover:border-foreground-500 transition-all duration-200 whitespace-nowrap"
              >
                Read the Guide
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}